import { Select } from "@mantine/core";
import { SelectProps } from "@mantine/core";
import classes from "./inputSelect.module.css";
import Image from "next/image";
import selectClasses from "../Select/index.module.css";

export interface InputSelectProps {
  width: number;
  side: "left" | "right";
}

const rightSection = <Image src="/images/icons/chevron-small-down.svg" alt="arrowDown" width={24} height={24} />;

const InputSelect = ({ width, side, ...selectProps }: InputSelectProps & SelectProps) => {
  return (
    <Select
      allowDeselect={false}
      {...selectProps}
      rightSection={rightSection}
      classNames={{
        ...classes,
        wrapper: side === "left" ? classes.wrapperLeft : classes.wrapperRight,
        section: side === "left" ? classes.sectionLeft : classes.sectionRight,
        input: `${classes.input} ${selectClasses.input}`,
      }}
      withCheckIcon={false}
    />
  );
};

export default InputSelect;
